<div class="h-100" [class.ng-cloak]="!showPage" [class.not-authorized]="notAuthorized">
    <div id="app-container" class="app-container" [className]="(sidebar$ | async)?.containerClassnames">
        <app-topnav [hideSettingsMenu]="notAuthorized"></app-topnav>
        <main class="main-container" [class.main-container_static]="!sidebarService.showSidebar">
            <div id="main-container-wrapper" class="main-container__wrapper">
                <router-outlet></router-outlet>
            </div>
        </main>
    </div>
</div>

<router-outlet name="popup" (activate)="modalService.lockBodyScroll()"
               (deactivate)="modalService.unlockBodyScroll()"></router-outlet>
